import { useEffect, useState } from 'react';

/**
 * Элемент, который исчезает с анимацией: после закрытия остаётся в DOM ещё exitMs, чтобы
 * CSS-анимация закрытия успела отыграть, затем размонтируется. Замена AnimatePresence из Motion
 */
export const usePresence = (open: boolean, exitMs: number) => {
  const [mounted, setMounted] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }
    const timer = window.setTimeout(() => setMounted(false), exitMs);
    return () => window.clearTimeout(timer);
  }, [open, exitMs]);

  return { mounted: open || mounted, closing: !open && mounted };
};
